<template>
  <div class="login-box">
    <img class="img-bj" src="@/assets/img/images/login-bj.png" />
    <div class="login-form-box">
      <p class="p1">{{ $t("login.title1") }}</p>
      <div class="tab-box">
        <!-- <div
          :class="{ sel: activeName === 'phone_login' }"
          @click="handleClick('phone_login')"
        >
          {{ $t("login.phone_login") }}
        </div> -->
        <div
          :class="{ sel: activeName === 'email_login' }"
          @click="handleClick('email_login')"
        >
          {{ $t("login.email_login") }}
        </div>
      </div>
      <el-form
        v-if="activeName === 'phone_login'"
        :model="loginForm_phone"
        :rules="rules"
        ref="ruleFormPhone"
      >
        <el-form-item :label="$t('login.input_phone1')">
          <el-input
            v-model="phoneNum"
            :placeholder="$t('tipsVal.inputPlaceholder')"
            @change="phoneNumUpdate"
            @keyup.enter.native="loginSend"
          />
        </el-form-item>
        <el-form-item :label="$t('login.pwd')" prop="password">
          <el-input
            v-model="loginForm_phone.password"
            :type="showPassword ? '' : 'password'"
            :placeholder="$t('login.input_password')"
            @keyup.enter.native="loginSend"
          >
            <template slot="suffix">
              <img
                v-if="!showPassword"
                @click="showPassword = !showPassword"
                class="eye-img"
                src="@/assets/img/images/icon/eye1.png"
              />
              <img
                v-if="showPassword"
                @click="showPassword = !showPassword"
                class="eye-img"
                src="@/assets/img/images/icon/eye2.png"
              />
            </template>
          </el-input>
        </el-form-item>
        <div class="title-box">
          <div>
            {{ $t("login.tips")
            }}<span @click="$router.push({ path: '/register' })">
              {{ $t("login.register_now") }}</span
            >
          </div>
          <div @click="$router.push({ path: '/forgetPassword' })">
            {{ $t("login.forget") }}
          </div>
        </div>
        <el-button class="login-btn" :loading="loading" @click="loginSend">{{
          $t("login.login")
        }}</el-button>
      </el-form>
      <el-form
        v-if="activeName === 'email_login'"
        :model="loginForm_email"
        :rules="rules"
        ref="ruleFormEmail"
      >
        <el-form-item :label="$t('login.email')" prop="username">
          <el-input
            v-model="loginForm_email.username"
            :placeholder="$t('tipsVal.inputPlaceholder')"
            @keyup.enter.native="loginSend"
          />
        </el-form-item>
        <el-form-item :label="$t('login.pwd')" prop="password">
          <el-input
            v-model="loginForm_email.password"
            :type="showPassword ? '' : 'password'"
            :placeholder="$t('login.input_password')"
            @keyup.enter.native="loginSend"
          >
            <template slot="suffix">
              <img
                v-if="!showPassword"
                @click="showPassword = !showPassword"
                class="eye-img"
                src="@/assets/img/images/icon/eye1.png"
              />
              <img
                v-if="showPassword"
                @click="showPassword = !showPassword"
                class="eye-img"
                src="@/assets/img/images/icon/eye2.png"
              />
            </template>
          </el-input>
        </el-form-item>
        <div class="title-box">
          <div>
            {{ $t("login.tips")
            }}<span @click="$router.push({ path: '/register' })">
              {{ $t("login.register_now") }}</span
            >
          </div>
          <div @click="$router.push({ path: '/forgetPassword' })">
            {{ $t("login.forget") }}
          </div>
        </div>
        <el-button class="login-btn" :loading="loading" @click="loginSend">{{
          $t("login.login")
        }}</el-button>
      </el-form>
    </div>

    <LoginVerifySMS ref="loginVerifySMSRef" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import LoginVerifySMS from "@/components/Dialog/LoginVerifySMS";
export default {
  name: "login",
  components: { LoginVerifySMS },
  data() {
    return {
      showPassword: false,

      loading: false,
      verifyLoading: false,
      verifyFlag: false,
      activeName: "email_login",
      captchaObj: null,
      translations: {
        phoneNumberLabel: this.$t("login.input_phone"),
      },
      phoneValidateMes: {
        show: false,
        mes: "",
      },
      phoneNum: "",
      loginForm_phone: {
        challenge: "",
        password: "",
        source: "web",
        username: "",
      },
      loginForm_email: {
        challenge: "",
        password: "",
        source: "web",
        username: "",
      },
      verifyData: {
        hint: "短信验证码已发送至手机",
        token: "",
        verifyCode: "",
        verifyType: "",
      },
      rules: {
        username: [
          {
            required: true,
            message: this.$t("validate.account_require"),
            trigger: "blur",
          },
        ],
        password: [
          {
            required: true,
            message: this.$t("validate.password_require"),
            trigger: "blur",
          },
          {
            min: 6,
            max: 32,
            message: "长度在 6 到 32 个字符",
            trigger: "blur",
          },
        ],
      },
    };
  },
  computed: {
    ...mapState(["user", "errorCode"]),
  },
  mounted() {
    let this_vue = this;
    this.$axios
      .post("/geetest/startCaptcha?t=" + new Date().getTime())
      .then((res) => {
        //console.log(res);
        let data = res.data;
        initGeetest(
          {
            gt: data.gt,
            challenge: data.challenge,
            offline: !data.success,
            new_captcha: true,
            product: "bind",
          },
          function (captchaObj) {
            this_vue.captchaObj = captchaObj;
            captchaObj
              .onReady(function () {
                // $("#wait").hide();
              })
              .onSuccess(function () {
                let result = captchaObj.getValidate();
                if (!result) {
                  this_vue.$message({
                    type: "error",
                    message: this_vue.$t("validate.geet_require"),
                  });
                } else {
                  this_vue.$axios
                    .post("/geetest/verifyLogin", {
                      challenge: data.challenge,
                      geetest_challenge: result.geetest_challenge,
                      geetest_validate: result.geetest_validate,
                      geetest_seccode: result.geetest_seccode,
                    })
                    .then((res) => {
                      this_vue.loading = true;
                      this_vue.loginForm_phone.challenge =
                        this_vue.loginForm_email.challenge = data.challenge;
                      let param =
                        this_vue.activeName === "phone_login"
                          ? this_vue.loginForm_phone
                          : this_vue.loginForm_email;
                      param.challenge = data.challenge;
                      this_vue.$axios
                        .post("/user/signIn", param)
                        .then((res) => {
                          this_vue.loading = false;
                          if (res.data.code === this_vue.errorCode.ok) {
                            if (res.data.data.needVerify) {
                              this_vue.verifyData.verifyCode = "";
                              this_vue.verifyData.hint = res.data.data.hint;
                              this_vue.verifyData.token = res.data.data.token;
                              this_vue.verifyData.verifyType =
                                res.data.data.verifyType;
                              this_vue.$refs.loginVerifySMSRef.init(
                                this_vue.verifyData,
                              );
                            } else {
                              window.localStorage.setItem(
                                "jwt-token",
                                res.data.data.jwtToken,
                              );
                              this_vue.$store.commit(
                                "userLogin",
                                res.data.data,
                              );
                              this_vue.$router.push({ path: "/" });
                            }
                          } else {
                            this_vue.$message({
                              type: "error",
                              message: res.data.msg,
                            });
                          }
                        })
                        .catch(() => {
                          this_vue.loading = false;
                        });
                    });
                }
              });
          },
        );
      });
  },
  methods: {
    handleClick(val) {
      this.activeName = val;
    },
    //号码验证
    phoneNumBlur() {
      if (!this.loginForm_phone.username.trim()) {
        this.phoneValidateMes.mes = "请输入电话号码";
        this.phoneValidateMes.show = true;
      } else {
        this.phoneValidateMes.show = false;
      }
    },
    phoneNumUpdate(val) {
      this.loginForm_phone.username = this.phoneNum = val;
    },
    loginSend() {
      let ref = null;
      if (this.activeName === "phone_login") {
        ref = this.$refs["ruleFormPhone"];
      } else {
        const emailValue = this.loginForm_email.username;
        const regEmail = /^([a-zA-Z0-9]+[-_.]?)+@[a-zA-Z0-9]+(\.[a-zA-Z]+)+$/;
        if (!emailValue) {
          this.$message({
            type: "error",
            message: this.$t("login.input_email"),
          });
          return false;
        }
        if (!regEmail.test(emailValue)) {
          this.$message({
            type: "error",
            message: this.$t("login.input_email1"),
          });
          return false;
        }
        ref = this.$refs["ruleFormEmail"];
      }
      ref.validate((valid) => {
        if (!valid) {
          return false;
        } else {
          this.captchaObj.verify();
        }
      });
    },
    //二次验证登录
    loginWithVerify() {
      if (!this.verifyData.verifyCode.trim()) {
        this.$message({
          type: "error",
          message: this.$t("validate.code_require"),
        });
      } else {
        this.verifyLoading = true;
        this.$axios
          .post("/user/signInConfirm", this.verifyData)
          .then((res) => {
            this.verifyLoading = false;
            if (res.data.code === this.errorCode.ok) {
              window.localStorage.setItem("jwt-token", res.data.data.jwtToken);
              this.$store.commit("userLogin", res.data.data);
              this.$store.commit("updateToken", res.data.data.jwtToken);
              this.$router.push({ path: "/" });
            } else {
              this.$message({
                type: "error",
                message: res.data.msg,
              });
            }
          })
          .catch(() => {
            this.verifyLoading = false;
          });
      }
    },
  },
};
</script>

<style lang="less" scoped>
.login-box {
  width: 100%;
  display: flex;
  position: relative;
  background: #f5f6f7;
  justify-content: center;
  height: calc(100% - 120px);
  /deep/ .el-form-item__label::before {
    content: "" !important;
  }
  .img-bj {
    top: 0;
    left: 0;
    z-index: 1;
    width: 100%;
    position: absolute;
  }
  .login-form-box {
    z-index: 2;
    width: 680px;
    margin-top: 60px;
    height: fit-content;
    position: relative;
    padding: 60px 88px;
    background: #ffffff;
    border-radius: 20px 20px 20px 20px;
    /deep/ .el-form {
      margin-top: 40px;
    }
    .p1 {
      font-family: PingFang SC, PingFang SC;
      font-weight: 800;
      font-size: 40px;
      color: #333333;
    }
    .login-btn {
      background: #4063ff;
      border-radius: 8px 8px 8px 8px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 20px;
      color: #ffffff;
      width: 100%;
      margin-top: 32px;
    }
    .title-box {
      div {
        cursor: pointer;
      }
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      font-size: 18px;
      color: #333333;
      display: flex;
      justify-content: space-between;
      span {
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 18px;
        color: #4063ff;
      }
    }
    /deep/ .el-input__suffix,
    /deep/ .el-input__suffix-inner {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .eye-img {
      width: 25px;
      height: 25px;
      margin-right: 6px;
    }
    .tab-box {
      gap: 40px;
      display: flex;
      margin-top: 20px;
      margin-bottom: 10px;
      border-bottom: 1px solid #e2e3e3;
      div {
        padding-bottom: 20px;
        cursor: pointer;
        font-family: PingFang SC, PingFang SC;
        font-weight: 400;
        font-size: 16px;
        color: #666666;
      }
      .sel {
        font-weight: 800;
        font-size: 16px;
        color: #4063ff;
        position: relative;
      }
      .sel::before {
        content: "";
        position: absolute;
        display: block;
        left: 0;
        width: 100%;
        bottom: 0;
        border-bottom: 1px solid #4063ff;
      }
    }
  }
}
</style>
